module.exports = __webpack_public_path__ + "img/CTE1mbl.5eb1b2c6.png";